export interface ScheduledCommunicationType extends ScheduledCommunicationTypeList {
  baselineMetric: ScheduledCommunicationTypeBaselineMetricTypes
  defaultToApproved: boolean
  leadTime: number
  numberOfScheduleUnits: number
  scheduleUnits: ScheduledCommunicationTypeScheduleUnits
  scheduledCommunicationChannel: ScheduledCommunicationTypeChannels
  timeToSend: string
}

export interface NewScheduledCommunicationTypeDetails extends ScheduledCommunicationTypeList {
  createdAt: string
  defaultToApproved: boolean
  leadTime: number
}

export interface ScheduledCommunicationTypeList {
  active: boolean
  description: string
  id: number
  timeToSend: string
}

export enum ScheduledCommunicationTypeChannels {
  SMS = 'SMS',
}

export enum ScheduledCommunicationTypeScheduleUnits {
  Days = 'Days',
  Months = 'Months',
  Weeks = 'Weeks',
}

export enum ScheduledCommunicationTypeBaselineMetricTypes {
  AfterBeginningOfMonth = 'After beginning of month',
  AfterMoveIn = 'After move-in',
  AfterMoveOut = 'After move-out',
  BeforeEndOfMonth = 'Before end of month',
  BeforeMoveIn = 'Before move-in',
  BeforeMoveOut = 'Before move-out',
  BookedWithLanding = 'Booked with Landing',
}
